module.exports = __webpack_public_path__ + "static/media/banner_aliexpress@2x.188c5f93.png";